<template>
  <div>
    <v-chip-group row class="mb-3 types" v-model="innerValue" @change="onChange">
      <v-chip
        filter
        large
        tile
        color="primary"
        class="type"
        outlined
        v-for="type in types"
        :key="type[idValue]"
        :value="type[idValue]"
        :disabled="disabled"
      >
        {{ type[textValue] }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      innerValue: "",
    }
  },
  props: {
    value: String,
    types: Array,
    textValue: { type: String, default: "text" },
    idValue: { type: String, default: "id" },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    const index = this.types.map((x) => x[this.idValue]).indexOf(this.value)
    if (index > -1) {
      this.innerValue = this.types[index][this.idValue]
    } else {
      this.innerValue = this.types[0][this.idValue]
    }
    this.onChange()
  },
  methods: {
    onChange() {
      this.$emit("input", this.innerValue)
    },
  },
}
</script>

<style>
.types .type {
  border-radius: 0;
}
</style>
